import * as xAPIConstants from '../constants/xAPIConstants';
import * as appData from '../models/appModels';
import * as scormConstants from '../constants/scormConstants';
import * as objectConstants from '../constants/objectConstants';
import * as appHelper from '../helpers/appHelper';
import * as dataHelper from '../helpers/dataHelper';
import * as appConstants from  '../constants/appConstants';
import xAPI from '../wrappers/xapi/xAPIWrap';
import _ from 'lodash';
import striptags from 'striptags';

class xAPIService {

    static checkActorDefined(contentData) {
        return new Promise(function (resolve, reject) {
            let conf = {
                endpoint: contentData.experience.lrs.end_point,
                user: contentData.experience.lrs.key,
                password: contentData.experience.lrs.secret,
            };
            let lrs = new xAPI.Lrs(conf);
            lrs.changeConfig(conf);
            resolve(lrs);
        });
    }

    static initTracking(contentData, trackingData, instructor) {

        return new Promise(function (resolve, reject) {
            let suspend_data = trackingData.suspend_data;
            let lesson_location = trackingData.lesson_location;
            let lesson_status = trackingData.lesson_status;

            let conf = {
                endpoint: contentData.experience.lrs.end_point,
                user: contentData.experience.lrs.key,
                password: contentData.experience.lrs.secret,
            };

            //let lrs = new xAPI.Lrs(conf);
            let lrs = new xAPI.Lrs();


            if(typeof lrs.lrs  === 'undefined' || typeof lrs.lrs.auth === 'undefined' || typeof lrs.lrs.endpoint === 'undefined'){
                lrs.changeConfig(conf);
            }

            if (!appHelper.isDefined(lrs.lrs.actor) && appHelper.isDefined(trackingData.actor)) {
                lrs.lrs.actor = JSON.stringify(trackingData.actor);
            }

            let url = lrs.getCurrentUrl();

            if(appConstants.OVERWRITE_ACTIVITY_ID_URL && appConstants.DEVELOPMENT_MODE){
                url = appConstants.OVERWRITTEN_ACTIVITY_ID_URL;
            }

            let actor = JSON.parse(lrs.lrs.actor);

            let activityId = `${typeof lrs.lrs.activity_id !== 'undefined' ? lrs.lrs.activity_id : `${lrs.getCurrentUrl()}/project_id:${contentData.experience.project_id }/experience_id:${contentData.experience.experience_id}`}`;

            if(appConstants.OVERWRITE_ACTIVITY_ID_URL && appConstants.DEVELOPMENT_MODE){
                activityId = `${appConstants.OVERWRITTEN_ACTIVITY_ID_URL}/experience:${contentData.experience.experience_id}`;
            }


            let settings = {
                student: {
                    id: '2099981',
                    name: 'Daniel Steff',
                    homePage: url
                },
                project:{
                    id: `${url}/project_id:${contentData.experience.project_id }`,
                    name: appHelper.getLocalData(contentData.experience).project_title,
                },
                activity: {
                    id: activityId,
                    name: appHelper.getLocalData(contentData.experience).experience_title,
                    description: "",
                },
                conf: {
                    endpoint: xAPIConstants.LRS_END_POINT,
                    user: xAPIConstants.LRS_KEY,
                    password: xAPIConstants.LRS_SECRET,
                }
            };

            //console.log(`settings`,settings);
            lrs.updateSettings(settings);

            let user = {
                account: {
                    name: lrs.settings.student.id,
                    homePage: lrs.settings.student.homePage
                }
            };

            trackingData = Object.assign({}, trackingData, {
                lrs: lrs
            });

            //GET SUSPEND_DATA
            function getSuspendData() {
                lrs.getState(
                    lrs.settings.activity.id,
                    new lrs.Agent(actor, actor.name),
                    "suspend_data")
                    .then(response => {
                        suspend_data = response.suspend_data;

                        trackingData = Object.assign({}, trackingData, {
                            suspend_data: suspend_data
                        });

                        getLessonLocation();
                    }).catch(error => {
                    getLessonLocation();
                });
            }

            //GET LESSON_LOCATION (BOOKMARK)
            function getLessonLocation() {
                lrs.getState(
                    lrs.settings.activity.id,
                    new lrs.Agent(actor, actor.name),
                    "lesson_location")
                    .then(response => {
                        let lesson_location = response.lesson_location;
                        trackingData = Object.assign({}, trackingData, {
                            lesson_location: lesson_location
                        });
                        checkCompleteRecord();
                    }).catch(error => {
                    trackingData = Object.assign({}, trackingData, {
                        lesson_location: contentData.experience.bites[0].screens[0].screen_id
                    });
                    checkCompleteRecord();
                });
            }

            //CHECK FOR A COMPLETE RECORD
            function checkCompleteRecord() {
                let search = lrs.searchParams();
                search['verb'] = lrs.Verbs.completed.id;
                search['activity'] = lrs.settings.activity.id;
                search['agent'] = new lrs.Agent(actor, actor.name);
                search['limit'] = 1;

                lrs.getStatements(search).then(response => {
                    let raw_score = 0;
                    if (response.statements.length > 0) {
                        lesson_status = scormConstants.LESSON_STATUS_COMPLETED;
                        if (typeof response.statements[0].result.score !== 'undefined') {
                            raw_score = response.statements[0].result.score.raw;
                        }
                    }
                    trackingData = Object.assign({}, trackingData, {
                        lesson_status: lesson_status,
                        raw_score: raw_score,
                    });
                    sendLaunchStatement();
                }).catch(error => {
                    sendLaunchStatement();
                });
            }

            function sendLaunchStatement() {

                let stmt = new lrs.Statement(
                    new lrs.Agent(actor, actor.name),
                    lrs.Verbs.launched,
                    new lrs.Activity(lrs.settings.activity.id, lrs.settings.activity.name, lrs.settings.activity.description, xAPIConstants.MODULE_ACTIVITY_TYPE)
                );

                let group =  {
                    id:`${lrs.settings.project.id}`,
                    objectType: 'Activity',
                    definition: {
                        name: {
                            en: lrs.settings.project.name
                        },
                        type: xAPIConstants.PROJECT_ACTIVITY_TYPE
                    }
                };
                stmt = lrs.addGroupingActivity(stmt, group);


                let categoryObj = {
                    id: `${xAPIConstants.ACTIVITY_URL_ID}/${xAPIConstants.EXPERIENCE_CODE}`,
                    objectType: 'Activity',
                    definition: {
                        name: {
                            en: xAPIConstants.EXPERIENC_LABEL
                        },
                        type: xAPIConstants.MODULE_ACTIVITY_TYPE
                    }
                };

                //console.log(`sendLaunchStatement instructor`, instructor);

                if(appHelper.isDefined(lrs.lrs.instructor)){
                    let instructorObj = JSON.parse(lrs.lrs.instructor);
                    stmt = lrs.addInstructor(stmt, lrs.Agent(instructorObj, instructorObj.name));
                }

                stmt = lrs.addCategoryActivity(stmt, categoryObj);

                lrs.sendStatement(stmt).then(response => {
                    let studentNameObj = appHelper.setStudentName(actor.name);
                    trackingData = Object.assign({}, trackingData, {
                        initialised: true,
                        student_name: studentNameObj.student_name,
                        first_name: studentNameObj.first_name,
                        last_name: studentNameObj.last_name
                    });

                    resolve(trackingData);

                }).catch(error => {

                    if (appData.SETTINGS.DEVELOPMENT_MODE) {
                        const student_name = "Lastname, Firstname";
                        let studentNameObj = appHelper.setStudentName(student_name);

                        trackingData = Object.assign({}, trackingData, {
                            initialised: true,
                            student_name: studentNameObj.student_name,
                            first_name: studentNameObj.first_name,
                            last_name: studentNameObj.last_name
                        });

                        resolve(trackingData);
                    } else {
                        throw(error);
                    }
                });

            }

            getSuspendData();

        });
    }

    static setLessionLocation(lesson_location, lrs) {
        return new Promise(function (resolve, reject) {
            let user = {
                account: {
                    name: lrs.settings.student.id,
                    homePage: lrs.settings.student.homePage
                }
            };
            let lessionLocation = {"lesson_location": lesson_location};

            let actor = JSON.parse(lrs.lrs.actor);

            lrs.sendState(
                lrs.settings.activity.id,
                new lrs.Agent(actor, actor.name),
                "lesson_location",
                null,
                lessionLocation
            ).then(response => {
                resolve(true);
            }).catch(error => {
                reject(error);
            });
        });
    }

    static setSuspendData(suspend_data, lrs) {
        return new Promise(function (resolve, reject) {
            let user = {
                account: {
                    name: lrs.settings.student.id,
                    homePage: lrs.settings.student.homePage
                }
            };
            let suspendData = {"suspend_data": suspend_data};

            let actor = JSON.parse(lrs.lrs.actor);

            lrs.sendState(
                lrs.settings.activity.id,
                new lrs.Agent(actor, actor.name),
                "suspend_data",
                null,
                suspendData
            ).then(response => {
                resolve(true);
            }).catch(error => {
                reject(error);
            });

            resolve(true);
        });
    }

    static markComplete(lrs, bites, contentData, instructor) {
        return new Promise(function (resolve, reject) {
            let user = {
                account: {
                    name: lrs.settings.student.id,
                    homePage: lrs.settings.student.homePage
                }
            };
            let result = {};
            let currentCompleteResult = {};
            let actor = JSON.parse(lrs.lrs.actor);

            //SET RESULT
            function setResult() {
                let scores = [];
                let totalScore = 0;
                let avgScore = 100;
                let scoreScaled = 0;
                let scoreMax = 100;
                let scoreMin = 0;

                let totalweight = 0;
                _.forEach(bites, function (bite) {
                    let primaryKpi = appHelper.getArrayObjectByKey(bite.kpis, "is_primary", true);
                    if (appHelper.isDefined(primaryKpi)) {
                        let score = dataHelper.getRangePercentage(primaryKpi.min, primaryKpi.max, primaryKpi.current);
                        if (isNaN(score)) {
                            score = scormConstants.CMI_CORE_SCORE_MAX_DEFAULT;
                        }

                        let weightedScore = score * bite.weight;

                        scores.push(weightedScore);
                        totalScore += weightedScore;
                        totalweight += bite.weight;
                    }
                });

                avgScore = Math.round(totalScore / totalweight);
                scoreScaled = new Number(avgScore / scoreMax);

                if (isNaN(avgScore)) {
                    avgScore = scormConstants.CMI_CORE_SCORE_MAX_DEFAULT;
                }

                let hasScore = avgScore >= 0 && scores.length > 0;

                if (avgScore >= 0 && scores.length > 0) {
                    let scoreObj = {
                        scaled: scoreScaled,
                        raw: avgScore,
                        min: scoreMin,
                        max: scoreMax
                    };

                    result = {
                        completion: true,
                        success: true,
                        score: scoreObj,
                        //response: 'Module Complete'
                    };
                } else {
                    result = {
                        completion: true,
                        //success: true,
                        //response: "Module Complete"
                    };
                }
                checkCompleteRecord();
            }


            //CHECK FOR A COMPLETE RECORD
            function checkCompleteRecord() {
                let search = lrs.searchParams();
                search['verb'] = lrs.Verbs.completed.id;
                search['activity'] = lrs.settings.activity.id;
                search['agent'] = new lrs.Agent(actor, actor.name);
                search['limit'] = 1;

                lrs.getStatements(search).then(response => {
                    if (response.statements.length > 0) {
                        currentCompleteResult = response.statements[0];
                        if (typeof result.score !== 'undefined' && result.score.raw > currentCompleteResult.result.score.raw) {
                            voidCompleteStatement();
                        } else {
                            //Don't send new record
                        }
                    } else {
                        sendCompleteStatement();
                    }

                }).catch(error => {
                    sendCompleteStatement();
                });
            }

            //VOID COMPLETE STATEMENT
            function voidCompleteStatement() {
                let stmt = new lrs.Statement(
                    new lrs.Agent(actor, actor.name),
                    lrs.Verbs.voided,
                    new lrs.StatementRef(currentCompleteResult.id)
                );

                lrs.sendStatement(stmt).then(response => {
                    sendCompleteStatement();
                }).catch(error => {
                    sendCompleteStatement();
                });
            }


            //SEND COMPLETE STATEMENT
            function sendCompleteStatement() {
                let stmt = new lrs.Statement(
                    new lrs.Agent(actor, actor.name),
                    lrs.Verbs.completed,
                    new lrs.Activity(lrs.settings.activity.id, lrs.settings.activity.name, lrs.settings.activity.description, xAPIConstants.MODULE_ACTIVITY_TYPE)
                );
                stmt.generateId();
                stmt.result = result;

                let group =  {
                    id:`${lrs.settings.project.id}`,
                    objectType: 'Activity',
                    definition: {
                        name: {
                            en: lrs.settings.project.name
                        },
                        type: xAPIConstants.PROJECT_ACTIVITY_TYPE
                    }
                };
                stmt = lrs.addGroupingActivity(stmt, group);

                let categoryObj = {
                    id: `${xAPIConstants.ACTIVITY_URL_ID}/${xAPIConstants.EXPERIENCE_CODE}`,
                    objectType: 'Activity',
                    definition: {
                        name: {
                            en: xAPIConstants.EXPERIENC_LABEL
                        },
                        type: xAPIConstants.MODULE_ACTIVITY_TYPE
                    }
                };
                stmt = lrs.addCategoryActivity(stmt, categoryObj);

                //console.log(`sendCompleteStatement instructor`, instructor);

                if(appHelper.isDefined(lrs.lrs.instructor)){
                    let instructorObj = JSON.parse(lrs.lrs.instructor);
                    stmt = lrs.addInstructor(stmt, lrs.Agent(instructorObj, instructorObj.name));
                }

                lrs.sendStatement(stmt).then(response => {
                    resolve(result);
                }).catch(error => {
                    reject(error);
                });
            }

            //SEND KPI RESULTS
            function sendKpiResults() {
                _.forEach(bites, function (bite) {
                    if (appHelper.isDefined(bite.kpis) && bite.kpis.length > 0) {
                        _.forEach(bite.kpis, function (kpi) {
                            checkKpiCompleteRecord(bite, kpi);
                        });
                    }
                });
            }


            function checkKpiCompleteRecord(bite, kpi) {
                let biteData = appHelper.getArrayObjectByKey(contentData.experience.bites, "bite_id", bite.bite_id);
                let score_kpi = biteData.score_kpi;
                let performance_kpis = biteData.performance_kpis;
                let targetKpi = {};
                if (appHelper.isDefined(score_kpi.kpi_id) && kpi.kpi_id === score_kpi.kpi_id) {
                    targetKpi = Object.assign({}, score_kpi);
                } else {
                    _.forEach(performance_kpis, function (p_kpi) {
                        if (kpi.kpi_id === p_kpi.kpi_id) {
                            targetKpi = Object.assign({}, p_kpi);
                        }
                    });
                }

                if (appHelper.isDefined(targetKpi.kpi_id)) {
                    let kpiLocale = appHelper.getLocalData(targetKpi);
                    let id = `${lrs.settings.activity.id}/bite_id:${bite.bite_id}/kpi_id:${targetKpi.kpi_id}`;
                    let search = lrs.searchParams();
                    search['verb'] = lrs.Verbs.scored.id;
                    search['activity'] = id;
                    search['agent'] = new lrs.Agent(actor, actor.name);
                    search['limit'] = 1;

                    lrs.getStatements(search).then(response => {
                        if (response.statements.length === 0) {
                            sendKpiCompleteStatement(targetKpi, kpiLocale, id, kpi.current.toFixed(targetKpi.decimal_points), bite.bite_id);
                        }
                    }).catch(error => {
                        sendKpiCompleteStatement();
                    });
                }
            }

            function sendKpiCompleteStatement(targetKpi, kpiLocale, id, current, bite_id) {
                if (appHelper.isDefined(targetKpi)) {
                    let bite = appHelper.getBiteById(bite_id);
                    let rawScore = dataHelper.getRangePercentage(targetKpi.min, targetKpi.max, current);

                    let scoreObj = {
                        scaled: rawScore / 100,
                        raw: parseFloat(current),
                        min: targetKpi.min,
                        max: targetKpi.max
                    };

                    let result = {
                        completion: true,
                        success: true,
                        score: scoreObj,
                        //response: "KPI Score"
                    };

                    let actor = JSON.parse(lrs.lrs.actor);
                    let stmt = new lrs.Statement(
                        new lrs.Agent(actor, actor.name),
                        lrs.Verbs.scored,
                        new lrs.Activity(id, kpiLocale.long_title, kpiLocale.description, xAPIConstants.OBJECTIVE_ACTIVITY_TYPE)
                    );

                    stmt.result = result;

                    //console.log(stmt);

                    stmt.generateId();

                    stmt = lrs.generateRegistration(stmt);

                    let parent =  {
                        id:`${lrs.settings.activity.id}/bite_id:${bite.bite_id}`,
                        objectType: 'Activity',
                        definition: {
                            name: {
                                en: appHelper.getLocalData(bite).title
                            },
                            type: xAPIConstants.SECTION_ACTIVITY_TYPE
                        }
                    };
                    stmt = lrs.addParentActivity(stmt, parent);

                    let moduleParent =  {
                        id: lrs.settings.activity.id,
                        objectType: 'Activity',
                        definition: {
                            name: {
                                en: lrs.settings.activity.name
                            },
                            type: xAPIConstants.MODULE_ACTIVITY_TYPE
                        }
                    };
                    stmt.context.contextActivities.parent.push(moduleParent);

                    let categoryObj = {
                        id: `${xAPIConstants.ACTIVITY_URL_ID}/${xAPIConstants.KPI_CODE}`,
                        objectType: 'Activity',
                        definition: {
                            name: {
                                en: xAPIConstants.KPI_LABEL
                            },
                            type: xAPIConstants.OBJECTIVE_ACTIVITY_TYPE
                        }
                    };
                    stmt = lrs.addCategoryActivity(stmt, categoryObj);



                    //console.log(`sendKpiCompleteStatement instructor`, instructor);

                    if(appHelper.isDefined(lrs.lrs.instructor)){
                        let instructorObj = JSON.parse(lrs.lrs.instructor);
                        stmt = lrs.addInstructor(stmt, lrs.Agent(instructorObj, instructorObj.name));
                    }

                    lrs.sendStatement(stmt).then(response => {
                        resolve(stmt);
                    }).catch(error => {
                        reject(error);
                    });
                }
            }


            //SEND INDICATOR RESULTS

            //SEND KPI RESULTS
            function sendIndicatorResults() {
                _.forEach(bites, function (bite) {
                    if (appHelper.isDefined(bite.indicators) && bite.indicators.length > 0) {
                        _.forEach(bite.indicators, function (indicator) {

                            checkIndicatorCompleteRecord(bite, indicator);
                        });
                    }
                });
            }


            function checkIndicatorCompleteRecord(bite, indicator) {
                //console.log(`checkIndicatorCompleteRecord`,indicator.indicator_id);
                let biteData = appHelper.getArrayObjectByKey(contentData.experience.bites, "bite_id", bite.bite_id);
                let bite_indicators = biteData.indicators;
                let targetIndicator = {};

                _.forEach(bite_indicators, function (p_indicator) {
                    if (indicator.indicator_id === p_indicator.indicator_id) {
                        targetIndicator = Object.assign({}, p_indicator);
                    }
                });


                if (appHelper.isDefined(targetIndicator.indicator_id)) {
                    let indicatorLocale = appHelper.getLocalData(targetIndicator);
                    let outcome = appHelper.getArrayObjectByKey(targetIndicator.outcomes,"indicator_outcome_id",indicator.currentOutcome.indicator_outcome_id);
                    //console.log(`outcome`,outcome);
                    let outcomeLocale = appHelper.getLocalData(outcome);
                    //console.log(`outcomeLocale`,outcomeLocale);
                    let id = `${lrs.settings.activity.id}/bite_id:${bite.bite_id}/indicator_id:${targetIndicator.indicator_id}`;
                    //console.log(`id`,id);
                    let search = lrs.searchParams();
                    search['verb'] = lrs.Verbs.scored.id;
                    search['activity'] = id;
                    search['agent'] = new lrs.Agent(actor, actor.name);
                    search['limit'] = 1;

                    lrs.getStatements(search).then(response => {
                        if (response.statements.length === 0) {
                            //console.log(`search results, ${response.statements.length}`);
                            sendIndicatorCompleteStatement(indicator, indicatorLocale,outcomeLocale, id, indicator.current, bite.bite_id);
                        }
                    }).catch(error => {
                        //console.log(`catch`);
                        sendIndicatorCompleteStatement();
                    });
                }
            }

            function sendIndicatorCompleteStatement(indicator, indicatorLocale, outcomeLocale, id, current, bite_id) {

                if (appHelper.isDefined(indicator)) {
                    //console.log(`sendIndicatorCompleteStatement` ,indicator);
                    let bite = appHelper.getBiteById(bite_id);
                    let rawScore = dataHelper.getRangePercentage(indicator.min, indicator.max, current);
                    //console.log(`indicator`,indicator);
                    let scoreObj = {
                        scaled: rawScore / 100,
                        raw: parseFloat(current),
                        min: indicator.min,
                        max: indicator.max
                    };

                    let result = {
                        completion: true,
                        success: true,
                        score: scoreObj,
                        response: outcomeLocale.title
                    };

                    //console.log(`result`,result);

                    let actor = JSON.parse(lrs.lrs.actor);
                    let stmt = new lrs.Statement(
                        new lrs.Agent(actor, actor.name),
                        lrs.Verbs.scored,
                        new lrs.Activity(id, indicatorLocale.long_title, indicatorLocale.description, xAPIConstants.OBJECTIVE_ACTIVITY_TYPE)
                    );

                    stmt.result = result;

                    //console.log(stmt);

                    stmt.generateId();

                    stmt = lrs.generateRegistration(stmt);

                    let parent =  {
                        id:`${lrs.settings.activity.id}/bite_id:${bite.bite_id}`,
                        objectType: 'Activity',
                        definition: {
                            name: {
                                en: appHelper.getLocalData(bite).title
                            },
                            type: xAPIConstants.SECTION_ACTIVITY_TYPE
                        }
                    };
                    stmt = lrs.addParentActivity(stmt, parent);

                    let moduleParent =  {
                        id: lrs.settings.activity.id,
                        objectType: 'Activity',
                        definition: {
                            name: {
                                en: lrs.settings.activity.name
                            },
                            type: xAPIConstants.MODULE_ACTIVITY_TYPE
                        }
                    };
                    stmt.context.contextActivities.parent.push(moduleParent);

                    let categoryObj = {
                        id: `${xAPIConstants.ACTIVITY_URL_ID}/${xAPIConstants.INDICATOR_CODE}`,
                        objectType: 'Activity',
                        definition: {
                            name: {
                                en: xAPIConstants.INDICATOR_LABEL
                            },
                            type: xAPIConstants.OBJECTIVE_ACTIVITY_TYPE
                        }
                    };
                    stmt = lrs.addCategoryActivity(stmt, categoryObj);



                    //console.log(`sendKpiCompleteStatement instructor`, instructor);

                    if(appHelper.isDefined(lrs.lrs.instructor)){
                        let instructorObj = JSON.parse(lrs.lrs.instructor);
                        stmt = lrs.addInstructor(stmt, lrs.Agent(instructorObj, instructorObj.name));
                    }

                    //console.log(`stmt`, stmt);

                    lrs.sendStatement(stmt).then(response => {
                        resolve(stmt);
                    }).catch(error => {
                        reject(error);
                    });
                }
            }

            sendKpiResults();

            sendIndicatorResults();

            setResult();
            resolve(true);
        });
    }

    static postActvityStatement(screen, interactionData, category, voidCompleteRecords, lrs, contentData, instructor ) {
        return new Promise(function (resolve, reject) {

            let user = {
                account: {
                    name: lrs.settings.student.id,
                    homePage: lrs.settings.student.homePage
                }
            };

            let actor = JSON.parse(lrs.lrs.actor);

            let screen_id = screen.screen_id;
            let screenLocale = appHelper.getLocalData(screen);
            let screenTitle = screenLocale.title;
            let parentScreen = appHelper.geScreenParentDetails(screen_id);
            let bite_id = appHelper.getBiteByScreenId(screen_id);
            let bite = appHelper.getBiteById(bite_id);

            let id = `${lrs.settings.activity.id}/bite_id:${bite_id}/screen_id:${screen.screen_id}`;
            if(typeof parentScreen !== 'undefined'){
                id = `${lrs.settings.activity.id}/bite_id:${bite_id}/screen_id:${parentScreen.screen_id}/sub_screen_id:${screen.screen_id}`;
            }

            let stmt = new lrs.Statement(
                new lrs.Agent(actor, actor.name),
                lrs.Verbs.answered,
                new lrs.Activity(id, lrs.settings.activity.name, lrs.settings.activity.description, xAPIConstants.QUESTION_ACTIVITY_TYPE)
            );
            stmt.result = interactionData.result;
            stmt.object = Object.assign({}, interactionData.object, {
                id: `${stmt.object.id}/${interactionData.object.id}`
            });

            stmt.generateId();


            /*let parent =  {
                id:id,
                objectType: 'Activity',
                definition: {
                    name: {
                        en: screenTitle
                    },
                    type: xAPIConstants.PAGE_ACTIVITY_TYPE
                }
            };
            stmt = lrs.addParentActivity(stmt, parent);

            if(typeof parentScreen !== 'undefined'){
                let parentScreenLocale = appHelper.getLocalData(parentScreen);
                let sub_screen_parent =  {
                    id:`${lrs.settings.activity.id}/bite_id:${bite_id}/screen_id:${parentScreen.screen_id}`,
                    objectType: `Activity`,
                    definition: {
                        name: {
                            en: parentScreenLocale.title
                        },
                        type: xAPIConstants.PAGE_ACTIVITY_TYPE

                    }
                };
                stmt.context.contextActivities.parent.push(sub_screen_parent);
            }

            let biteParent =  {
                id:`${lrs.settings.activity.id}/bite_id:${bite_id}`,
                objectType: 'Activity',
                definition: {
                    name: {
                        en: bite.en.title
                    },
                    type: xAPIConstants.SECTION_ACTIVITY_TYPE
                }
            };
            stmt.context.contextActivities.parent.push(biteParent);

            let moduleParent =  {
                id: lrs.settings.activity.id,
                objectType: 'Activity',
                definition: {
                    name: {
                        en: lrs.settings.activity.name
                    },
                    type: xAPIConstants.MODULE_ACTIVITY_TYPE
                }
            };
            stmt.context.contextActivities.parent.push(moduleParent);*/

            /*let parent =  {
                id: lrs.settings.activity.id,
                objectType: 'Activity',
                definition: {
                    name: {
                        en: lrs.settings.activity.name
                    },
                    type: xAPIConstants.MODULE_ACTIVITY_TYPE
                }
            };

            stmt = lrs.addParentActivity(stmt, parent);*/

            let parent =  {
                id:`${lrs.settings.activity.id}/bite_id:${bite.bite_id}`,
                objectType: 'Activity',
                definition: {
                    name: {
                        en: appHelper.getLocalData(bite).title
                    },
                    type: xAPIConstants.SECTION_ACTIVITY_TYPE
                }
            };

            let group = {
                id:`${lrs.settings.activity.id}`,
                objectType: 'Activity',
                definition: {
                    name: {
                        en:  `${lrs.settings.activity.name}`,
                    },
                    type: xAPIConstants.MODULE_ACTIVITY_TYPE
                }
            };

            let categoryObj = {
                id: `${xAPIConstants.ACTIVITY_URL_ID}/${category.constant}`,
                objectType: 'Activity',
                definition: {
                    name: {
                        en: category.label
                    },
                    type: xAPIConstants.QUESTION_ACTIVITY_TYPE
                }
            };

            //console.log(`postActvityStatement instructor`, instructor);

            if(appHelper.isDefined(lrs.lrs.instructor)){
                let instructorObj = JSON.parse(lrs.lrs.instructor);
                stmt = lrs.addInstructor(stmt, lrs.Agent(instructorObj, instructorObj.name));
            }

            stmt = lrs.addGroupingActivity(stmt, group);
            stmt = lrs.addParentActivity(stmt, parent);
            stmt = lrs.addCategoryActivity(stmt, categoryObj);
            stmt = lrs.generateRegistration(stmt);

            if(appHelper.isDefined(voidCompleteRecords) && voidCompleteRecords){
                checkCompleteRecord();
            }else {

                sendCompleteStatement();
            }

            function checkCompleteRecord() {

                let search = lrs.searchParams();
                search['verb'] = lrs.Verbs.answered.id;
                search['activity'] = stmt.object.id;
                search['agent'] = new lrs.Agent(actor, actor.name);
                search['limit'] = 1;

                lrs.getStatements(search).then(response => {
                    if (response.statements.length > 0) {
                        let currentCompleteResult = response.statements[0];
                            voidCompleteStatement(currentCompleteResult);
                    } else {
                        sendCompleteStatement();
                    }

                }).catch(error => {
                    sendCompleteStatement();
                });
            }

            //VOID COMPLETE STATEMENT
            function voidCompleteStatement(currentCompleteResult) {
                let new_stmt = new lrs.Statement(
                    new lrs.Agent(actor, actor.name),
                    lrs.Verbs.voided,
                    new lrs.StatementRef(currentCompleteResult.id)
                );

                lrs.sendStatement(new_stmt).then(response => {
                    sendCompleteStatement();
                }).catch(error => {

                    sendCompleteStatement();
                });
            }

            function sendCompleteStatement(){
                lrs.sendStatement(stmt).then(response => {
                    resolve(stmt);
                }).catch(error => {
                    reject(error);
                });

                resolve(stmt);
            }

        });
    }

    static getActivityStatement(interactionData, lrs) {
        return new Promise(function (resolve, reject) {
            let user = {
                account: {
                    name: lrs.settings.student.id,
                    homePage: lrs.settings.student.homePage
                }
            };

            let actor = JSON.parse(lrs.lrs.actor);

            let search = lrs.searchParams();
            search['verb'] = lrs.Verbs.answered.id;
            search['activity'] = `${lrs.settings.activity.id}/${interactionData.activityId}`;
            search['agent'] = new lrs.Agent(actor, actor.name);
            search['limit'] = 1;

            lrs.getStatements(search).then(response => {
                resolve(
                    Object.assign({}, interactionData,
                        {
                            statement: response.statements[0]
                        }
                    )
                );
            }).catch(error => {
                reject(error);
            });

        });
    }

    static setScreenAccessed(screen, parentScreen, bite, lrs) {
        return new Promise(function (resolve, reject) {
            let user = {
                account: {
                    name: lrs.settings.student.id,
                    homePage: lrs.settings.student.homePage
                }
            };

            let result = {
                completion: true,
                //success: true,
                //response: "Screen Accessed"
            };

            let actor = JSON.parse(lrs.lrs.actor);
            let screenLocale = appHelper.getLocalData(screen);

            let id = `${lrs.settings.activity.id}/bite_id:${bite.bite_id}/screen_id:${screen.screen_id}`;
            if(typeof parentScreen !== 'undefined'){
                id = `${lrs.settings.activity.id}/bite_id:${bite.bite_id}/screen_id:${parentScreen.screen_id}/sub_screen_id:${screen.screen_id}`;
            }

            let stmt = new lrs.Statement(
                new lrs.Agent(actor, actor.name),
                lrs.Verbs.progressed,
                new lrs.Activity(id, screenLocale.title, lrs.settings.activity.description, xAPIConstants.PAGE_ACTIVITY_TYPE)
            );

            stmt.result = result;
            stmt.generateId();




            let parent =  {
                id:`${lrs.settings.activity.id}/bite_id:${bite.bite_id}`,
                objectType: 'Activity',
                definition: {
                    name: {
                        en: appHelper.getLocalData(bite).title
                    },
                    type: xAPIConstants.SECTION_ACTIVITY_TYPE
                }
            };



            let moduleParent =  {
                id: lrs.settings.activity.id,
                objectType: 'Activity',
                definition: {
                    name: {
                        en: lrs.settings.activity.name
                    },
                    type: xAPIConstants.MODULE_ACTIVITY_TYPE
                }
            };
            stmt.context.contextActivities.parent.push(moduleParent);

            let categoryObj = {
                id: `${xAPIConstants.ACTIVITY_URL_ID}/${xAPIConstants.SCREEN_CODE}`,
                objectType: 'Activity',
                definition: {
                    name: {
                        en: xAPIConstants.SCREEN_LABEL
                    },
                    type: xAPIConstants.PAGE_ACTIVITY_TYPE
                }
            };

            if(typeof parentScreen !== 'undefined'){
                let parentScreenLocale = appHelper.getLocalData(parentScreen);
                parent =  {
                    id:`${lrs.settings.activity.id}/bite_id:${bite.bite_id}/screen_id:${parentScreen.screen_id}`,
                    objectType: `Activity`,
                    definition: {
                        name: {
                            en: parentScreenLocale.title
                        }
                    }
                };

                categoryObj = {
                    id: `${xAPIConstants.ACTIVITY_URL_ID}/${xAPIConstants.SUB_SCREEN_CODE}`,
                    objectType: 'Activity',
                    definition: {
                        name: {
                            en: xAPIConstants.SUB_SCREEN_LABEL
                        },
                        type: xAPIConstants.SUB_PAGE_ACTIVITY_TYPE
                    }
                };
            }
            stmt = lrs.addParentActivity(stmt, parent);
            stmt = lrs.addCategoryActivity(stmt, categoryObj);

            lrs.sendStatement(stmt).then(response => {
                resolve(stmt);
            }).catch(error => {
                reject(error);
            });

            resolve(stmt);
        });
    }

    static setScreenComplete(screen, parentScreen, bite, lrs, instructor) {
        return new Promise(function (resolve, reject) {
            let user = {
                account: {
                    name: lrs.settings.student.id,
                    homePage: lrs.settings.student.homePage
                }
            };

            let result = {
                completion: true,
                //success: true,
                //response: "Screen Completed"
            };

            let actor = JSON.parse(lrs.lrs.actor);
            let screenLocale = appHelper.getLocalData(screen);

            let id = `${lrs.settings.activity.id}/bite_id:${bite.bite_id}/screen_id:${screen.screen_id}`;
            if(typeof parentScreen !== 'undefined'){
                id = `${lrs.settings.activity.id}/bite_id:${bite.bite_id}/screen_id:${parentScreen.screen_id}/sub_screen_id:${screen.screen_id}`;
            }


            let stmt = new lrs.Statement(
                new lrs.Agent(actor, actor.name),
                lrs.Verbs.completed,
                new lrs.Activity(id, screenLocale.title, lrs.settings.activity.description, xAPIConstants.PAGE_ACTIVITY_TYPE)
            );

            checkCompleteRecord();

            function checkCompleteRecord() {
                let search = lrs.searchParams();
                search['verb'] = lrs.Verbs.completed.id;
                search['activity'] = id;
                search['agent'] = new lrs.Agent(actor, actor.name);
                search['limit'] = 1;

                lrs.getStatements(search).then(response => {
                    if (response.statements.length === 0) {
                        sendCompleteStatement();
                    } else {
                        //console.log(`${id} has already been marked complete`);
                    }
                }).catch(error => {
                    sendCompleteStatement();
                });
            }

            function sendCompleteStatement() {

                stmt.result = result;

                let parent =  {
                    id:`${lrs.settings.activity.id}/bite_id:${bite.bite_id}`,
                    objectType: `Activity`,
                    definition: {
                        name: {
                            en: appHelper.getLocalData(bite).title
                        },
                        type: xAPIConstants.SECTION_ACTIVITY_TYPE
                    }
                };

                let categoryObj = {
                    id: `${xAPIConstants.ACTIVITY_URL_ID}/${xAPIConstants.SCREEN_CODE}`,
                    objectType: 'Activity',
                    definition: {
                        name: {
                            en: xAPIConstants.SCREEN_LABEL
                        },
                        type: xAPIConstants.PAGE_ACTIVITY_TYPE
                    }
                };

                if(typeof parentScreen !== 'undefined'){
                    let parentScreenLocale = appHelper.getLocalData(parentScreen);
                    parent =  {
                        id:`${lrs.settings.activity.id}/bite_id:${bite.bite_id}/screen_id:${parentScreen.screen_id}`,
                        objectType: 'Activity',
                        definition: {
                            name: {
                                en: parentScreenLocale.title
                            },
                            type: xAPIConstants.PAGE_ACTIVITY_TYPE
                        }
                    };
                    categoryObj = {
                        id: `${xAPIConstants.ACTIVITY_URL_ID}/${xAPIConstants.SUB_SCREEN_CODE}`,
                        objectType: 'Activity',
                        definition: {
                            name: {
                                en: xAPIConstants.SUB_SCREEN_LABEL
                            },
                            type: xAPIConstants.SUB_PAGE_ACTIVITY_TYPE
                        }
                    };
                }

                //console.log(`setScreenComplete sendCompleteStatement instructor`, instructor);

                if(appHelper.isDefined(lrs.lrs.instructor)){
                    let instructorObj = JSON.parse(lrs.lrs.instructor);
                    stmt = lrs.addInstructor(stmt, lrs.Agent(instructorObj, instructorObj.name));
                }

                stmt.generateId();
                stmt = lrs.addParentActivity(stmt, parent);
                stmt = lrs.addCategoryActivity(stmt, categoryObj);

                if(typeof parentScreen !== 'undefined'){
                    let biteParent =  {
                        id:`${lrs.settings.activity.id}/bite_id:${bite.bite_id}`,
                        objectType: 'Activity',
                        definition: {
                            name: {
                                en: appHelper.getLocalData(bite).title
                            },
                            type: xAPIConstants.SECTION_ACTIVITY_TYPE
                        }
                    };
                    stmt.context.contextActivities.parent.push(biteParent);
                }

                let moduleParent =  {
                    id: lrs.settings.activity.id,
                    objectType: 'Activity',
                    definition: {
                        name: {
                            en: lrs.settings.activity.name
                        },
                        type: xAPIConstants.MODULE_ACTIVITY_TYPE
                    }
                };
                stmt.context.contextActivities.parent.push(moduleParent);

                lrs.sendStatement(stmt).then(response => {
                    resolve(stmt);
                }).catch(error => {
                    reject(error);
                });
            }

            resolve(stmt);
        });


    }

    static setBadgeStatement(badge, bite_id, lrs, instructor) {
        return new Promise(function (resolve, reject) {
            let user = {
                account: {
                    name: lrs.settings.student.id,
                    homePage: lrs.settings.student.homePage
                }
            };

            let result = {
                completion: true,
                //success: true,
                //response: "Badge Collected"
            };

            let actor = JSON.parse(lrs.lrs.actor);
            let id = `${lrs.settings.activity.id}/bite_id:${bite_id}/badge_id:${badge.badge_id}`;
            let badgeLocale = appHelper.getLocalData(badge);
            let bite = appHelper.getBiteById(bite_id);
            let currentCompleteResult = {};


            //CHECK FOR A COMPLETE RECORD
            function checkCompleteRecord() {
                //console.log('checkCompleteRecord');
                let search = lrs.searchParams();
                search['verb'] =  lrs.Verbs.earned.id;
                search['activity'] = id;
                search['agent'] = new lrs.Agent(actor, actor.name);
                search['limit'] = 1;

                lrs.getStatements(search).then(response => {
                    if (response.statements.length === 0) {
                        sendCompleteStatement();
                    }
                }).catch(error => {
                    sendCompleteStatement();
                });
            }

            //SEND COMPLETE STATEMENT
            function sendCompleteStatement() {
                let stmt = new lrs.Statement(
                    new lrs.Agent(actor, actor.name),
                    lrs.Verbs.earned,
                    new lrs.Activity(id, badgeLocale.long_title, badgeLocale.description, xAPIConstants.BADGE_ACTIVITY_TYPE)
                );

                stmt.result = result;

                stmt.generateId();

                let parent =  {
                    id:`${lrs.settings.activity.id}/bite_id:${bite_id}`,
                    objectType: 'Activity',
                    definition: {
                        name: {
                            en: appHelper.getLocalData(bite).title
                        },
                        type: xAPIConstants.SECTION_ACTIVITY_TYPE
                    }
                };
                stmt = lrs.addParentActivity(stmt, parent);

                let moduleParent =  {
                    id: lrs.settings.activity.id,
                    objectType: 'Activity',
                    definition: {
                        name: {
                            en: lrs.settings.activity.name
                        },
                        type: xAPIConstants.MODULE_ACTIVITY_TYPE
                    }
                };
                stmt.context.contextActivities.parent.push(moduleParent);

                let categoryObj = {
                    id: `${xAPIConstants.ACTIVITY_URL_ID}/${xAPIConstants.BADGE_CODE}`,
                    objectType: 'Activity',
                    definition: {
                        name: {
                            en: xAPIConstants.BADGE_LABEL
                        },
                        type: xAPIConstants.BADGE_ACTIVITY_TYPE
                    }
                };
                stmt = lrs.addCategoryActivity(stmt, categoryObj);

               // console.log(`setBadgeStatement sendCompleteStatement instructor`, instructor);

                if(appHelper.isDefined(lrs.lrs.instructor)){
                    let instructorObj = JSON.parse(lrs.lrs.instructor);
                    stmt = lrs.addInstructor(stmt, lrs.Agent(instructorObj, instructorObj.name));
                }

                lrs.sendStatement(stmt).then(response => {
                    resolve(stmt);
                }).catch(error => {
                    reject(error);
                });
            }

            checkCompleteRecord();

            resolve(true);
        });
    }

    static setBiteProgressStatus(bite,biteStatus, userDataBite, parentScreen, lrs, instructor) {
        return new Promise(function (resolve, reject) {
            let user = {
                account: {
                    name: lrs.settings.student.id,
                    homePage: lrs.settings.student.homePage
                }
            };



            let actor = JSON.parse(lrs.lrs.actor);
            let id = `${lrs.settings.activity.id}/bite_id:${bite.bite_id}`;
            let biteLocale =  appHelper.getLocalData(bite).title;

            let result = {
                completion: true,
                //success: true,
                //response: "Bite Accessed"
            };




            function checkProgessRecord() {
                //console.log('checkProgessRecord');
                let search = lrs.searchParams();
                search['verb'] =  lrs.Verbs.progressed.id;
                search['activity'] = id;
                search['agent'] = new lrs.Agent(actor, actor.name);
                search['limit'] = 1;

                lrs.getStatements(search).then(response => {
                    if (response.statements.length === 0) {
                        sendProgressRecord();
                    } else {
                        //console.log(`${id} has already been marked complete`);
                    }
                }).catch(error => {
                    sendProgressRecord();
                });
            }
            
            
            function sendProgressRecord(){
                //console.log('sendProgressRecord');
                let stmt = new lrs.Statement(
                    new lrs.Agent(actor, actor.name),
                    lrs.Verbs.progressed,
                    new lrs.Activity(id, biteLocale, lrs.settings.activity.description, xAPIConstants.SECTION_ACTIVITY_TYPE)
                );

                stmt.result = result;

                stmt.generateId();
                let parent =  {
                    id: lrs.settings.activity.id,
                    objectType: 'Activity',
                    definition: {
                        name: {
                            en: lrs.settings.activity.name
                        },
                        type: xAPIConstants.MODULE_ACTIVITY_TYPE
                    }
                };
                stmt = lrs.addParentActivity(stmt, parent);

                let categoryObj = {
                    id: `${xAPIConstants.ACTIVITY_URL_ID}/${xAPIConstants.BITE_CODE}`,
                    objectType: 'Activity',
                    definition: {
                        name: {
                            en: xAPIConstants.BITE_LABEL
                        },
                        type: xAPIConstants.SECTION_ACTIVITY_TYPE
                    }
                };
                stmt = lrs.addCategoryActivity(stmt, categoryObj);

                //console.log(`setBiteProgressStatus sendProgressRecord instructor`, instructor);

                if(appHelper.isDefined(lrs.lrs.instructor)){
                    let instructorObj = JSON.parse(lrs.lrs.instructor);
                    stmt = lrs.addInstructor(stmt, lrs.Agent(instructorObj, instructorObj.name));
                }

                lrs.sendStatement(stmt).then(response => {
                    resolve(stmt);
                }).catch(error => {
                    reject(error);
                });

            }
            if(!appHelper.isDefined(parentScreen)){
                if(biteStatus == objectConstants.STATUS_IN_PROGRESS){
                    checkProgessRecord();
                }
            }


            resolve(true);
        });
    }

    static setBiteCompleteStatus(bite,biteStatus, userDataBite, parentScreen, lrs, instructor) {
        return new Promise(function (resolve, reject) {
            let user = {
                account: {
                    name: lrs.settings.student.id,
                    homePage: lrs.settings.student.homePage
                }
            };



            let actor = JSON.parse(lrs.lrs.actor);
            let id = `${lrs.settings.activity.id}/bite_id:${bite.bite_id}`;
            let biteLocale = appHelper.getLocalData(bite).title;
            let result = {};
            let currentCompleteResult = {};

            //SET RESULT
            function setResult() {

                //console.log('setResult');
                let scores = [];
                let totalScore = 0;
                let avgScore = 100;
                let scoreScaled = 0;
                let scoreMax = 100;
                let scoreMin = 0;

                let totalweight = 0;


                let primaryKpi = appHelper.getArrayObjectByKey(userDataBite.kpis, "is_primary", true);
                if (appHelper.isDefined(primaryKpi)) {
                    let score = dataHelper.getRangePercentage(primaryKpi.min, primaryKpi.max, primaryKpi.current);
                    if (isNaN(score)) {
                        score = scormConstants.CMI_CORE_SCORE_MAX_DEFAULT;
                    }

                    let weightedScore = score * userDataBite.weight;

                    scores.push(weightedScore);
                    totalScore += weightedScore;
                    totalweight += userDataBite.weight;
                }


                avgScore = Math.round(totalScore / totalweight);
                scoreScaled = new Number(avgScore / scoreMax);
                if (avgScore >= 0) {
                    let scoreObj = {
                        scaled: scoreScaled,
                        raw: avgScore,
                        min: scoreMin,
                        max: scoreMax
                    };

                    result = {
                        completion: true,
                        success: true,
                        score: scoreObj,
                        //response: 'Bite Complete'
                    };


                } else {
                    result = {
                        completion: true,
                        //success: true,
                        //response: "Bite Complete"
                    };
                }
                checkCompleteRecord();
            }



            //CHECK FOR A COMPLETE RECORD
            function checkCompleteRecord() {
                //console.log('checkCompleteRecord');
                let search = lrs.searchParams();
                search['verb'] =  lrs.Verbs.completed.id;
                search['activity'] = id;
                search['agent'] = new lrs.Agent(actor, actor.name);
                search['limit'] = 1;

                lrs.getStatements(search).then(response => {
                    if (response.statements.length > 0) {
                        currentCompleteResult = response.statements[0];
                        if (typeof result.score !== 'undefined' && result.score.raw > currentCompleteResult.result.score.raw) {
                            voidCompleteStatement();
                        } else {
                            //Don't send new record
                        }
                    } else {
                        sendCompleteStatement();
                    }

                }).catch(error => {
                    sendCompleteStatement();
                });
            }

            //VOID COMPLETE STATEMENT
            function voidCompleteStatement() {
                //console.log('voidCompleteStatement');
                let stmt = new lrs.Statement(
                    new lrs.Agent(actor, actor.name),
                    lrs.Verbs.voided,
                    new lrs.StatementRef(currentCompleteResult.id)
                );

                lrs.sendStatement(stmt).then(response => {
                    sendCompleteStatement();
                }).catch(error => {
                    sendCompleteStatement();
                });
            }

            //SEND COMPLETE STATEMENT
            function sendCompleteStatement() {
                //console.log('sendCompleteStatement');
                let stmt = new lrs.Statement(
                    new lrs.Agent(actor, actor.name),
                    lrs.Verbs.completed,
                    new lrs.Activity(id, biteLocale, lrs.settings.activity.description, xAPIConstants.SECTION_ACTIVITY_TYPE)
                );
                stmt.generateId();
                stmt.result = result;
                let parent =  {
                    id: lrs.settings.activity.id,
                    objectType: 'Activity',
                    definition: {
                        name: {
                            en: lrs.settings.activity.name
                        },
                        type: xAPIConstants.MODULE_ACTIVITY_TYPE
                    }
                };
                stmt = lrs.addParentActivity(stmt, parent);

                let categoryObj = {
                    id: `${xAPIConstants.ACTIVITY_URL_ID}/${xAPIConstants.BITE_CODE}`,
                    objectType: 'Activity',
                    definition: {
                        name: {
                            en: xAPIConstants.BITE_LABEL
                        },
                        type: xAPIConstants.SECTION_ACTIVITY_TYPE
                    }
                };
                stmt = lrs.addCategoryActivity(stmt, categoryObj);

                //console.log(`setBiteCompleteStatus sendCompleteStatement instructor`, instructor);

                if(appHelper.isDefined(lrs.lrs.instructor)){
                    let instructorObj = JSON.parse(lrs.lrs.instructor);
                    stmt = lrs.addInstructor(stmt, lrs.Agent(instructorObj, instructorObj.name));
                }

                lrs.sendStatement(stmt).then(response => {
                    resolve(result);
                }).catch(error => {
                    reject(error);
                });
            }


            if(!appHelper.isDefined(parentScreen)) {
                if (biteStatus == objectConstants.STATUS_COMPLETE) {
                    setResult();
                }
            }
            resolve(true);
        });
    }

    static setLinkAccessed(asset_id, label, lrs, instructor) {
        return new Promise(function (resolve, reject) {
            let user = {
                account: {
                    name: lrs.settings.student.id,
                    homePage: lrs.settings.student.homePage
                }
            };

            let result = {
                completion: true,
            };

            let actor = JSON.parse(lrs.lrs.actor);
            let id = `${lrs.settings.activity.id}/asset_id:${asset_id}`;

            let stmt = new lrs.Statement(
                new lrs.Agent(actor, actor.name),
                lrs.Verbs.accessed,
                new lrs.Activity(id, label, lrs.settings.activity.description, xAPIConstants.LINK_ACTIVITY_TYPE)
            );

            checkCompleteRecord();

            function checkCompleteRecord() {
                let search = lrs.searchParams();
                search['verb'] = lrs.Verbs.accessed.id;
                search['activity'] = id;
                search['agent'] = new lrs.Agent(actor, actor.name);
                search['limit'] = 1;

                lrs.getStatements(search).then(response => {
                    if (response.statements.length === 0) {
                        sendCompleteStatement();
                    } else {
                        //console.log(`${id} has already been marked complete`);
                    }
                }).catch(error => {
                    sendCompleteStatement();
                });
            }

            function sendCompleteStatement() {

                stmt.result = result;

                let parent = {
                    id: `${xAPIConstants.ACTIVITY_URL_ID}/${xAPIConstants.EXPERIENCE_CODE}`,
                    objectType: 'Activity',
                    definition: {
                        name: {
                            en: xAPIConstants.EXPERIENC_LABEL
                        },
                        type: xAPIConstants.MODULE_ACTIVITY_TYPE
                    }
                };

                let categoryObj = {
                    id: `${xAPIConstants.ACTIVITY_URL_ID}/${xAPIConstants.LINK_CODE}`,
                    objectType: 'Activity',
                    definition: {
                        name: {
                            en: xAPIConstants.LINK_LABEL
                        },
                        type: xAPIConstants.LINK_ACTIVITY_TYPE
                    }
                };

                stmt.generateId();
                stmt = lrs.addParentActivity(stmt, parent);
                stmt = lrs.addCategoryActivity(stmt, categoryObj);

                let moduleParent =  {
                    id: lrs.settings.activity.id,
                    objectType: 'Activity',
                    definition: {
                        name: {
                            en: lrs.settings.activity.name
                        },
                        type: xAPIConstants.MODULE_ACTIVITY_TYPE
                    }
                };

                stmt.context.contextActivities.parent.push(moduleParent);

                //console.log(`setLinkAccessed sendCompleteStatement instructor`, instructor);

                if(appHelper.isDefined(lrs.lrs.instructor)){
                    let instructorObj = JSON.parse(lrs.lrs.instructor);
                    stmt = lrs.addInstructor(stmt, lrs.Agent(instructorObj, instructorObj.name));
                }

                lrs.sendStatement(stmt).then(response => {
                    resolve(stmt);
                }).catch(error => {
                    reject(error);
                });
            }

            resolve(stmt);
        });


    }

    static setDocumentAccessed(asset_id, label, lrs, instructor) {
        return new Promise(function (resolve, reject) {
            let user = {
                account: {
                    name: lrs.settings.student.id,
                    homePage: lrs.settings.student.homePage
                }
            };

            let result = {
                completion: true,
            };

            let actor = JSON.parse(lrs.lrs.actor);
            let id = `${lrs.settings.activity.id}/asset_id:${asset_id}`;

            let stmt = new lrs.Statement(
                new lrs.Agent(actor, actor.name),
                lrs.Verbs.accessed,
                new lrs.Activity(id, label, lrs.settings.activity.description, xAPIConstants.DOCUMENT_ACTIVITY_TYPE)
            );

            checkCompleteRecord();

            function checkCompleteRecord() {
                let search = lrs.searchParams();
                search['verb'] = lrs.Verbs.accessed.id;
                search['activity'] = id;
                search['agent'] = new lrs.Agent(actor, actor.name);
                search['limit'] = 1;

                lrs.getStatements(search).then(response => {
                    if (response.statements.length === 0) {
                        sendCompleteStatement();
                    } else {
                        //console.log(`${id} has already been marked complete`);
                    }
                }).catch(error => {
                    sendCompleteStatement();
                });
            }

            function sendCompleteStatement() {

                stmt.result = result;

                let parent = {
                    id: `${xAPIConstants.ACTIVITY_URL_ID}/${xAPIConstants.EXPERIENCE_CODE}`,
                    objectType: 'Activity',
                    definition: {
                        name: {
                            en: xAPIConstants.EXPERIENC_LABEL
                        },
                        type: xAPIConstants.MODULE_ACTIVITY_TYPE
                    }
                };

                let categoryObj = {
                    id: `${xAPIConstants.ACTIVITY_URL_ID}/${xAPIConstants.DOCUMENT_CODE}`,
                    objectType: 'Activity',
                    definition: {
                        name: {
                            en: xAPIConstants.DOCUMENT_LABEL
                        },
                        type: xAPIConstants.DOCUMENT_ACTIVITY_TYPE
                    }
                };

                stmt.generateId();
                stmt = lrs.addParentActivity(stmt, parent);
                stmt = lrs.addCategoryActivity(stmt, categoryObj);

                let moduleParent =  {
                    id: lrs.settings.activity.id,
                    objectType: 'Activity',
                    definition: {
                        name: {
                            en: lrs.settings.activity.name
                        },
                        type: xAPIConstants.MODULE_ACTIVITY_TYPE
                    }
                };

                //console.log(`setDocumentAccessed sendCompleteStatement instructor`, instructor);

                if(appHelper.isDefined(lrs.lrs.instructor)){
                    let instructorObj = JSON.parse(lrs.lrs.instructor);
                    stmt = lrs.addInstructor(stmt, lrs.Agent(instructorObj, instructorObj.name));
                }

                stmt.context.contextActivities.parent.push(moduleParent);

                lrs.sendStatement(stmt).then(response => {
                    resolve(stmt);
                }).catch(error => {
                    reject(error);
                });
            }

            resolve(stmt);
        });


    }

    static setVideoOpened(asset_id, label, lrs, instructor) {
        return new Promise(function (resolve, reject) {
            let user = {
                account: {
                    name: lrs.settings.student.id,
                    homePage: lrs.settings.student.homePage
                }
            };

            let result = {
                completion: true,
            };

            let actor = JSON.parse(lrs.lrs.actor);
            let id = `${lrs.settings.activity.id}/asset_id:${asset_id}`;

            let stmt = new lrs.Statement(
                new lrs.Agent(actor, actor.name),
                lrs.Verbs.opened,
                new lrs.Activity(id, label, lrs.settings.activity.description, xAPIConstants.VIDEO_ACTIVITY_TYPE)
            );

            checkCompleteRecord();

            function checkCompleteRecord() {
                let search = lrs.searchParams();
                search['verb'] = lrs.Verbs.opened.id;
                search['activity'] = id;
                search['agent'] = new lrs.Agent(actor, actor.name);
                search['limit'] = 1;

                lrs.getStatements(search).then(response => {
                    if (response.statements.length === 0) {
                        sendCompleteStatement();
                    } else {
                        //console.log(`${id} has already been marked complete`);
                    }
                }).catch(error => {
                    sendCompleteStatement();
                });
            }

            function sendCompleteStatement() {

                stmt.result = result;

                let parent = {
                    id: `${xAPIConstants.ACTIVITY_URL_ID}/${xAPIConstants.EXPERIENCE_CODE}`,
                    objectType: 'Activity',
                    definition: {
                        name: {
                            en: xAPIConstants.EXPERIENC_LABEL
                        },
                        type: xAPIConstants.MODULE_ACTIVITY_TYPE
                    }
                };

                let categoryObj = {
                    id: `${xAPIConstants.ACTIVITY_URL_ID}/${xAPIConstants.VIDEO_CODE}`,
                    objectType: 'Activity',
                    definition: {
                        name: {
                            en: xAPIConstants.VIDEO_LABEL
                        },
                        type: xAPIConstants.VIDEO_ACTIVITY_TYPE
                    }
                };

                stmt.generateId();
                stmt = lrs.addParentActivity(stmt, parent);
                stmt = lrs.addCategoryActivity(stmt, categoryObj);

                let moduleParent =  {
                    id: lrs.settings.activity.id,
                    objectType: 'Activity',
                    definition: {
                        name: {
                            en: lrs.settings.activity.name
                        },
                        type: xAPIConstants.MODULE_ACTIVITY_TYPE
                    }
                };

                //console.log(`setVideoOpen sendCompleteStatement instructor`, instructor);

                if(appHelper.isDefined(lrs.lrs.instructor)){
                    let instructorObj = JSON.parse(lrs.lrs.instructor);
                    stmt = lrs.addInstructor(stmt, lrs.Agent(instructorObj, instructorObj.name));
                }

                stmt.context.contextActivities.parent.push(moduleParent);

                lrs.sendStatement(stmt).then(response => {
                    resolve(stmt);
                }).catch(error => {
                    reject(error);
                });
            }

            resolve(stmt);
        });


    }

    static setVideoPlayed(asset_id, label, lrs, instructor) {
        return new Promise(function (resolve, reject) {
            let user = {
                account: {
                    name: lrs.settings.student.id,
                    homePage: lrs.settings.student.homePage
                }
            };

            let result = {
                completion: true,
            };

            let actor = JSON.parse(lrs.lrs.actor);
            let id = `${lrs.settings.activity.id}/asset_id:${asset_id}`;

            let stmt = new lrs.Statement(
                new lrs.Agent(actor, actor.name),
                lrs.Verbs.played,
                new lrs.Activity(id, label, lrs.settings.activity.description, xAPIConstants.VIDEO_ACTIVITY_TYPE)
            );

            checkCompleteRecord();

            function checkCompleteRecord() {
                let search = lrs.searchParams();
                search['verb'] = lrs.Verbs.played.id;
                search['activity'] = id;
                search['agent'] = new lrs.Agent(actor, actor.name);
                search['limit'] = 1;

                lrs.getStatements(search).then(response => {
                    if (response.statements.length === 0) {
                        sendCompleteStatement();
                    } else {
                        //console.log(`${id} has already been marked complete`);
                    }
                }).catch(error => {
                    sendCompleteStatement();
                });
            }

            function sendCompleteStatement() {

                stmt.result = result;

                let parent = {
                    id: `${xAPIConstants.ACTIVITY_URL_ID}/${xAPIConstants.EXPERIENCE_CODE}`,
                    objectType: 'Activity',
                    definition: {
                        name: {
                            en: xAPIConstants.EXPERIENC_LABEL
                        },
                        type: xAPIConstants.MODULE_ACTIVITY_TYPE
                    }
                };

                let categoryObj = {
                    id: `${xAPIConstants.ACTIVITY_URL_ID}/${xAPIConstants.VIDEO_CODE}`,
                    objectType: 'Activity',
                    definition: {
                        name: {
                            en: xAPIConstants.VIDEO_LABEL
                        },
                        type: xAPIConstants.VIDEO_ACTIVITY_TYPE
                    }
                };

                stmt.generateId();
                stmt = lrs.addParentActivity(stmt, parent);
                stmt = lrs.addCategoryActivity(stmt, categoryObj);

                let moduleParent =  {
                    id: lrs.settings.activity.id,
                    objectType: 'Activity',
                    definition: {
                        name: {
                            en: lrs.settings.activity.name
                        },
                        type: xAPIConstants.MODULE_ACTIVITY_TYPE
                    }
                };

               // console.log(`setVideoPlayed sendCompleteStatement instructor`, instructor);

                if(appHelper.isDefined(lrs.lrs.instructor)){
                    let instructorObj = JSON.parse(lrs.lrs.instructor);
                    stmt = lrs.addInstructor(stmt, lrs.Agent(instructorObj, instructorObj.name));
                }

                stmt.context.contextActivities.parent.push(moduleParent);

                lrs.sendStatement(stmt).then(response => {
                    resolve(stmt);
                }).catch(error => {
                    reject(error);
                });
            }

            resolve(stmt);
        });


    }

}

export default xAPIService;


/** WEBPACK FOOTER **
 ** ./src/services/xAPIService.js
 **/